import * as React from "react"
import { cn } from "../../lib/utils"

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "destructive"
}

function Alert({ className, variant = "default", ...props }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        "w-full rounded-md border p-4 text-sm",
        variant === "destructive"
          ? "border-destructive/30 bg-destructive/10 text-destructive-foreground"
          : "border-border bg-card text-foreground",
        className
      )}
      {...props}
    />
  )
}

function AlertDescription({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-sm", className)} {...props} />
}

export { Alert, AlertDescription }
